namespace TabAurous.Production {
    export interface WorkOrderForm {
        TransDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        DepartmentId: Serenity.LookupEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        SelectDetails: WorkOrderSelectItemsEditor;
        Pieces: Serenity.IntegerEditor;
        NoofBags: Serenity.IntegerEditor;
        ItemDetails: WorkOrderItemsEditor;
    }

    export class WorkOrderForm extends Serenity.PrefixedContext {
        static formKey = 'Production.WorkOrder';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WorkOrderForm.init)  {
                WorkOrderForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.StringEditor;
                var w3 = s.LookupEditor;
                var w4 = WorkOrderSelectItemsEditor;
                var w5 = WorkOrderItemsEditor;

                Q.initFormType(WorkOrderForm, [
                    'TransDate', w0,
                    'VoucherTypeId', w1,
                    'VoucherNo', w2,
                    'DepartmentId', w3,
                    'UserId', w3,
                    'EmployeeId', w1,
                    'CompanyId', w1,
                    'FinancialYearId', w1,
                    'SelectDetails', w4,
                    'Pieces', w1,
                    'NoofBags', w1,
                    'ItemDetails', w5
                ]);
            }
        }
    }
}
